// extracted by mini-css-extract-plugin
export var cancelButton = "_ml-5";
export var content = "_ml-3";
export var createButton = "_ml-6";
export var drawerContainer = "_ml-0";
export var footer = "_ml-2";
export var header = "_ml-1";
export var orderFormColumn = "_ml-4";